
import { Data as MarketContent } from './market/index'
import { Data as AccountContent } from './account/index'
import { Data as IntroduceContent } from './introduce/index'
// import Introduce from './1_introduce.json'
import { Data as OtherContent } from '../../listenKey/index'
let aaa = JSON.stringify(OtherContent).replaceAll("/market/","/market?")
aaa = aaa.replaceAll("/market?<listenKey>","/market?listenKey=")
aaa = aaa.replaceAll("wss://open-api-ws.bingx.com/market?listenKey=","wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
const Other = {
    "path": "listenKey.html",
    "name": "Listen Key",
    "content": JSON.parse(aaa)
  }
const Market = {
    "path": "market.html",
    "name": "Websocket 行情推送",
    "content": MarketContent
}
const Account = {
    "path": "account.html",
    "name": "Websocket 賬戶信息推送",
    "content": AccountContent
}
const introduce = {
    "path": "",
    "name": "聯繫我們",
    "content": IntroduceContent
}

const list_temp = [
    introduce,
    Other,
    Market,
    Account
]
export const List = list_temp



// WEBPACK FOOTER //
// ./src/config/zh-tw/spot/websocket/index.js